"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Context_1 = require("./Context");
/**
 * Error Message for inputs
 */
var ErrorMessage = function (props) {
    var name = props.name;
    var form = (0, Context_1.useFormContext)();
    var errors = form.errors, touched = form.touched;
    // only show when the field has been touched and has error
    if (!(errors[name] && touched[name]))
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null, errors[name]));
};
exports.default = ErrorMessage;
